import { render, staticRenderFns } from "./LinksTable.vue?vue&type=template&id=5f0bc598"
import script from "./LinksTable.vue?vue&type=script&lang=js"
export * from "./LinksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports